import { ProductCategoryListingPage } from './ProductCategoryListingPage';

export default ProductCategoryListingPage;
